<script lang="ts">
	import type { Geometry } from '$lib/components/map/types';
	import {
		layout,
		lineColor,
		SELECTED_INNER_LINE_WIDTH,
		SELECTED_OUTTER_LINE_WIDTH,
		UNSELECTED_INNER_LINE_WIDTH,
		UNSELECTED_OUTTER_LINE_WIDTH,
	} from '$lib/components/map/routePolylines/constant';
	import GeoJsonLineLayer from '$lib/components/map/routePolylines/polylines/GeoJsonLineLayer.svelte';

	interface Props {
		geometries?: Geometry[];
		selectedRoute?: number;
		displayOnlySelected?: boolean;
		onPolylineClick?: (index: number) => void;
	}

	const {
		geometries,
		selectedRoute,
		displayOnlySelected = false,
		onPolylineClick = () => {},
	}: Props = $props();

	const sortedGeometries: Geometry[] = $derived.by(() => {
		if (displayOnlySelected) {
			return geometries?.filter(geometry => geometry.index === selectedRoute) ?? [];
		}

		return geometries?.concat().sort(geometry => (geometry.index === selectedRoute ? 1 : -1)) ?? [];
	});

	function getGeometryOutterLineColor(geometryIndex: number) {
		if (geometryIndex === selectedRoute) {
			return lineColor.dark;
		}

		return lineColor.viamichelin;
	}

	function getInnerLineColor(geometryIndex: number) {
		return geometryIndex === selectedRoute ? lineColor.viamichelin : lineColor.lightViamichelin;
	}
</script>

{#if sortedGeometries.length > 0}
	{#each sortedGeometries as geometry (JSON.stringify(geometry.line.coordinates))}
		<GeoJsonLineLayer
			{geometry}
			{layout}
			outterPaint={{
				'line-color': getGeometryOutterLineColor(geometry.index),
				'line-width': geometry.index === selectedRoute ? SELECTED_OUTTER_LINE_WIDTH : UNSELECTED_OUTTER_LINE_WIDTH,
			}}
			innerPaint={{
				'line-color': getInnerLineColor(geometry.index),
				'line-width': geometry.index === selectedRoute ? SELECTED_INNER_LINE_WIDTH : UNSELECTED_INNER_LINE_WIDTH,
			}}
			{onPolylineClick}
		/>
	{/each}
{/if}
